module.exports = __webpack_public_path__ + "img/location-tip.3e87c30f.jpg";